module.exports = __webpack_public_path__ + "static/media/TEMPLATE4.95181edf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adtemplates/TEMPLATE4.jpg
// module id = 1470
// module chunks = 1